<template>
  <div>
    <div v-if="showSearcher" class="overlay"></div>
    <div class="row mx-0 flight-info" :class="{ highlight: showSearcher }">
      <div class="col">
        <div v-show="!showSearcher && (!isMobile || (isMobile && expanded )) ">
          <div class="row align-items-center pax-container">
            <div v-if="search.adults" class="pax" :class="{ 'col-auto': !isMobile, 'pipe': search.minors || search.infants }">
              <i class="fas fa-user" /> <span>{{ $t('adults') }} {{ search.adults }}</span>
            </div>
            <div v-if="search.minors" class="pax" :class="{ 'col-auto': !isMobile, 'pipe': search.infants }">
              <i class="fas fa-child" /> <span>{{ $t('childs') }} {{ search.minors }}</span>
            </div>
            <div v-if="search.infants" class="pax" :class="!isMobile ? '' : 'col-auto'">
              <i class="fas fa-baby" /> <span>{{ $t('infants') }} {{ search.infants }}</span>
            </div>
            <div v-if="!isMobile" class="col-auto ml-auto">
              <button class="btn btn-primary" @click="showSearcher = !showSearcher">
                <i class="fas fa-pencil mr-2" /> <span>{{ $t('edit_selection') }}</span>
              </button>
            </div>
          </div>

          <div class="row align-items-start itinerary" :class="isMobile ? 'mt-1' : 'mt-3'" >
            <div :class="isMobile ? 'col-5' : 'col-auto'" class="itinerary__outbound">
              <div  class=" row flex-column">
                <div :class="isMobile ? '' : 'col-auto'">
                  <div :class="isMobile ? 'airportContainer' : 'row no-gutters'">
                    <div class=" code-container " :class="isMobile ? '' : 'col-auto'" >
                      <span class="code">{{ search.origin }}</span>
                    </div>
                    <div class="city-container" :class="isMobile ? '' : 'col-auto'">
                      <span class="city">{{ getLocationCity(search.origin) }}</span>
                    </div>
                  </div>
                </div>

                <div class="mt-2 --date  " :class="isMobile ? '' : 'col-auto'">
                  <span><span class="day-of-week">{{dates.departure.dayOfWeek}}</span> {{dates.departure.date}}</span>
                </div>
              </div>
            </div>

            <div class="col-auto itinerary__icon" :class="!isMobile? (isRoundTrip?  'mt-1' : 'mt-3') : ''">
              <div class="row flex-column" :class="{'round-trip': isRoundTrip}">
                <div class="col-auto">
                  <i class="fas fa-plane"></i>
                </div>
                <div v-if="isRoundTrip"  class="col-auto">
                  <i class="fas fa-plane" style="transform: scaleX(-1);"></i>
                </div>
              </div>
            </div>

            <div :class="isMobile ? 'col-5' : 'col-auto'" class="itinerary__return">
              <div class="row flex-column">
                <div :class="isMobile ? '' : 'col-auto'">
                  <div :class="isMobile ? 'airportContainer' : 'row no-gutters'">
                    <div class="code-container "  :class="isMobile ? '' : 'col-auto'">
                      <span class="code">{{ search.destination }}</span>
                    </div>
                    <div class=" city-container  "  :class="isMobile ? '' : 'col-auto'">
                      <span class="city">{{ getLocationCity(search.destination) }}</span>
                    </div>
                  </div>
                </div>

                <div v-if="isRoundTrip" class=" mt-2 --date"  :class="isMobile ? '' : 'col-auto'">
                  <span><span class="day-of-week">{{dates.return.dayOfWeek}}</span> {{dates.return.date}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CtwInfoSearchCollapsed
          v-if="isMobile && !expanded && !showSearcher"
          :search="search"
          :dates="dates"
        />

        <searcher
          class="pulse"
          v-show="showSearcher"
          searchIcon="fas fa-search"
          :showSimpleForm="false"
          :selectedSearchData="$store.getters.getSearchData"
          :renderSpa="'flightresults'"
          :customUrls="{
            base: $store.getters.getConfigUrls ? $store.getters.getConfigUrls.apiBaseUrl : ''
          }"
          :bookingData="searchFlightConfig"
        >
          <template v-slot:action-button>
            <div class="ml-auto">
              <button @click="showSearcher = !showSearcher" class="btn btn-outline-primary">
                {{ $t('back') }}
                <i class="ml-2 fas fa-arrow-right"></i>
              </button>
            </div>
          </template>
        </searcher>

      </div>

      <button v-if="isMobile && expanded && !showSearcher" class="btn btn-outline-primary" @click="showSearcher = !showSearcher">
        <i class="fas fa-pencil mr-2"></i> <span>{{ $t('edit_selection') }}</span>
      </button>

      <button v-if="isMobile && !showSearcher" class="btn searchForm__btnExpand"
                @click="expanded=!expanded"
        >
          <i :class="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Searcher from 'core-lib/components/searcher/Searcher.vue'
import CtwInfoSearchCollapsed from './CtwInfoSearchCollapsed.vue'
import moment from 'moment'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'CtwInfoSearch',
  components: {
    Searcher,
    CtwInfoSearchCollapsed
  },
  props: {
    search: {
      type: Object,
      required: true
    },
    airportsInfo: {
      type: Object,
      required: false
    }
  },
  inject: ['isMobile'],
  data () {
    return {
      showSearcher: false,
      expanded: false
    }
  },
  methods: {
    getLocationCity (code) {
      return this.airportsInfo
        ? this.airportsInfo[code].location_city_name.toLowerCase()
        : code
    }
  },
  mounted () {
    this.expanded = !this.isMobile
  },
  computed: {
    ...mapFields(['searchFlightConfig']),
    isRoundTrip () {
      return this.search.return_flight
    },
    dates () {
      const clean = (str) => str.replaceAll('.', '').toUpperCase()
      const date = (date) => clean(moment(date, 'DD/MM/YYYY').locale(this.lang).format('MMM YYYY'))
      const dayOfWeek = (date) => clean(moment(date, 'DD/MM/YYYY').locale(this.lang).format('ddd DD '))

      const dates = {
        departure: {
          date: date(this.search.departure_date),
          dayOfWeek: dayOfWeek(this.search.departure_date)
        },
        return: null
      }

      if (this.isRoundTrip) {
        dates.return = {
          date: date(this.search.return_date),
          dayOfWeek: dayOfWeek(this.search.return_date)
        }
      }

      return dates
    },
    lang () {
      return this.$store.getters.getLanguage
    }
  }
}
</script>

<style lang="sass" scoped>
$color-primary: var(--color-primary)
$color-secondary: var(--color-secondary)
$color-surface: var(--color-onSurface)
$font-size-xl: var(--font-size-xl)
$font-size-lg: var(--font-size-lg)
$font-size-md: var(--font-size-md)
$font-size-sm: var(--font-size-sm)
$font-size-base: var(--font-size-base)
$font-size-sbase: var(--font-size-sbase)

.flight-info
  background: white
  padding: 1rem
  border-radius: var(--b-radius-md)
  border-bottom: 8px solid var(--color-primary)
.pax-container
  .pax
    color: $color-surface
    i
      color: $color-secondary
  .pax.pipe
    border-right: 1px solid

.itinerary
    font-size: $font-size-md

    &__icon
      font-size: 18px
      color: $color-secondary
      .round-trip
        font-size: $font-size-sbase

    &__outbound,
    &__return
      color: $color-primary

      i
        color: $color-secondary

      .--date
        font-size: $font-size-base
        color: $color-surface
        i
          color: $color-surface
        .day-of-week
            margin-left: 5px
            padding: 4px
            border-radius: var(--b-radius-sm)
            font-weight: 600

      .city
        text-transform: capitalize
        font-size: $font-size-xl

      .code-container
        display: flex
        font-size: $font-size-md
        padding: 2px 4px
        margin-right: 12px
        align-items: center
        border-radius: var(--b-radius-sm)
        background: var(--color-overlay-05)

        .code
          padding: 2px

.Searcher.surface
  padding: 0
  border: none

  ::v-deep .searchForm
    &__datepicker
      flex-basis: 34%

.pulse
  animation-name: pulse
  animation-duration: 1s
  animation-fill-mode: both

@keyframes pulse
  0%
    transform: scale3d(1, 1, 1)
  50%
    transform: scale3d(1.03, 1.03, 1.03)
  100%
    transform: scale3d(1, 1, 1)

.overlay
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: var(--color-overlay-50)
  z-index: 9999

.highlight
  position: relative
  z-index: 9999

.btn-outline-primary
  font-size: $font-size-sm
  border: 1px solid $color-primary
  order: 0

.searchForm__btnExpand
  display: flex
  padding: 11px 11px 0px
  justify-content: center
  align-items: center
  gap: 10px
  align-self: stretch
  width: 100%
  border: none
  i
    opacity: .6

@media (max-width: 768px)

  .btn:hover
    box-shadow: 0px 0px !important
  .col
    padding-left: 0px
    padding-right: 0px
  .flight-info
    padding: 10px 5px 5px 5px !important
  .btn-outline-primary
    margin: 11px 0px 0px
    padding: 8px 11px 8px
    width: 100%
    font-size: var(--font-size-sm)
    border: 1px solid var(--color-primary)
    border-radius: var(--b-radius-sm)  !Important
    order: 0
  .pax-container
    margin: 0px
    gap: 8px
    font-size: var(--font-size-sm) !Important
    .pax
      padding: .25rem
      display: flex
      gap: .25rem
      align-items: center
      color: var(--color-onSurface) !Important
      background-color: var(--color-overlay-05) !Important
      border-radius: var(--b-radius-sm)  !Important
      i
        color: var(--color-secondary)
        font-size: .8rem
    .pax.pipe
      border-right: 0px solid !Important
      margin-left: 1px !Important
      margin-right: 1px !Important
  .itinerary
      margin: 0px
      justify-content: center
      border: 1px solid var(--color-overlay-10)
      border-radius: 10px
      &__icon
        display: flex
        width: 25px
        padding: 6px 0px
        flex-direction: column
        justify-content: center
        align-items: center
        align-self: stretch
      &__outbound,
      &__return
        padding: 8px 0px 12px 0px
        .code-container
          padding: 1px !Important
          margin-right: 0px
          margin: 3px
          order: 2
        .city
          font-size: var(--font-size-base) !Important
          font-weight: 700
        .code
          font-size: $font-size-lg !Important
          padding: 2px 4px !Important
        .--date
          font-size: var(--font-size-sm) !Important
          text-align: center
          i
            color: var(--color-onSurface)
          .day-of-week
              margin-left: 5px
              padding: 4px
              border-radius: var(--b-radius-sm)
              font-weight: 700
      .city-container
        font-size: $font-size-base  !Important
        text-align: center
        width: 100%

.airportContainer
  display: flex
  flex-direction: column
  align-items: center

</style>

<style lang="sass">
#originDropdownContainer,
#destinationDropdownContainer
  z-index: 9999

@media (max-width: 768px)
  .searchForm
    width: 100%
    padding: 0px 0px 10px 0px
    &__flightType
      order: 1
    &__datepicker
      flex-basis: 100% !Important
    &__countrySettings
      align-items: center
      display: flex
    .--tag
      margin: 0.25rem 0 !important
  .flight-info
    padding: 10px 0px 0px 0px  !Important
</style>
